import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutLeftFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-left-full, grid, window"} maskId="square-filled-radius-0-stroke-1-IconLayoutLeftFull"><path d="M3 21V3H9L9 21L3 21Z" fill="currentColor"/><path d="M10 21L21 21V3H10L10 21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutLeftFull;
